export default class Hero {
  constructor() {
    const hero = document.querySelector('.hero.brick');

    if (!hero) {
      return;
    }

    const btnScrollDown = document.querySelector('.hero__scroll-down');

    btnScrollDown?.addEventListener('click', () => {
      window.scrollTo({
        top: hero.offsetHeight,
        behavior: 'smooth',
      });
    });
  }
}
